/* eslint-disable max-classes-per-file */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import axios from "axios";
import camelCaseKeys from "camelcase-keys";
import snakeCaseKeys from "snakecase-keys";
var IGNORED_403_ERROR_CODE = "sso_disabled_invalid_operation";
var Err;
(function(Err) {
    Err["Network"] = "E_NETWORK";
    Err["UnknownServerException"] = "E_UNKNOWN_SERVER_EXCEPTION";
})(Err || (Err = {}));
export var RequestError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(RequestError, Error1);
    var _super = _createSuper(RequestError);
    function RequestError(message, request) {
        _classCallCheck(this, RequestError);
        var _this;
        _this = _super.call(this);
        _this.message = message;
        _this.stack = new Error().stack;
        _this.name = _this.constructor.name;
        _this.headers = request.headers;
        _this.type = _this.message === "Network Error" ? Err.Network : Err.UnknownServerException;
        return _this;
    }
    return RequestError;
}(_wrapNativeSuper(Error));
export var ResponseError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(ResponseError, Error1);
    var _super = _createSuper(ResponseError);
    function ResponseError(message, response) {
        _classCallCheck(this, ResponseError);
        var _this;
        var _response_data, _this_types;
        _this = _super.call(this);
        _this.message = message;
        _this.stack = new Error().stack;
        _this.name = _this.constructor.name;
        var status = response.status, statusText = response.statusText, headers = response.headers;
        _this.status = status;
        _this.statusText = statusText;
        _this.headers = headers;
        var _response_data_errors;
        _this.errors = (_response_data_errors = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.errors) !== null && _response_data_errors !== void 0 ? _response_data_errors : [];
        _this.types = _this.errors.map(function(param) {
            var code = param.code;
            return code;
        });
        var _this_types_;
        _this.type = (_this_types_ = (_this_types = _this.types) === null || _this_types === void 0 ? void 0 : _this_types[0]) !== null && _this_types_ !== void 0 ? _this_types_ : _this.message === "Network Error" ? Err.Network : Err.UnknownServerException;
        return _this;
    }
    return ResponseError;
}(_wrapNativeSuper(Error));
var DEFAULT_HEADERS = {
    Accept: "application/vnd.eventmobi+json; version=p.6",
    // Flux has read/write replicas so the result of POST/PATCH/DELETE call is not
    // immediately reflected on the subsequent GET call. To read directly from the
    // master database, we have the following header set to `true` for most of our
    // API calls until we have a permanent solution.
    "x-use-master-db": true
};
export default function(baseURL) {
    var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, withCredentials = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    for(var _len = arguments.length, options = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        options[_key - 3] = arguments[_key];
    }
    var api = axios.create(_objectSpread({
        baseURL: baseURL,
        headers: _objectSpread({}, DEFAULT_HEADERS, headers),
        withCredentials: withCredentials
    }, options));
    api.interceptors.request.use(function(request) {
        // anything that needs to be done before request is sent
        // can be done here
        if (request.data) {
            Object.assign(request, {
                data: snakeCaseKeys(request.data, {
                    deep: true
                })
            });
        }
        if (request.params && _instanceof(request.params, URLSearchParams)) {
            Object.assign(request, {
                params: snakeCaseKeys(Object.fromEntries(_toConsumableArray(request.params)))
            });
        }
        if (request.params && !_instanceof(request.params, URLSearchParams)) {
            Object.assign(request, {
                params: snakeCaseKeys(request.params, {
                    deep: true
                })
            });
        }
        return request;
    }, function(error) {
        return Promise.reject(new RequestError(error.message, error.request));
    });
    // Add a response interceptor
    api.interceptors.response.use(function(response) {
        var _response_data_meta, _response_data_meta_pagination;
        // Convert the response data from snake_case to camelCase
        Object.assign(response, {
            data: camelCaseKeys(response.data, {
                deep: true
            })
        });
        // Copy CMS-style pagination into UAPI-style pagination
        // https://eventmobi.slack.com/archives/C01183LHRRR/p1709758136464999
        if (typeof ((_response_data_meta = response.data.meta) === null || _response_data_meta === void 0 ? void 0 : (_response_data_meta_pagination = _response_data_meta.pagination) === null || _response_data_meta_pagination === void 0 ? void 0 : _response_data_meta_pagination.totalRecordCount) !== "undefined") {
            var pagination = response.data.meta.pagination;
            pagination.totalItemsCount = pagination.totalRecordCount;
            pagination.pageItemsCount = pagination.returnedRecordCount;
        }
        return response;
    }, function() {
        var _ref = _asyncToGenerator(function(error) {
            var _error_response, _error_request, _error_response1, _error_response_data, _error_response_data_errors, _error_response_data_errors_, status, _error_request_responseURL, responseURL, fluxErrorCode, isAuthRequest, currentPath;
            return __generator(this, function(_state) {
                status = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || 200;
                responseURL = (_error_request_responseURL = error === null || error === void 0 ? void 0 : (_error_request = error.request) === null || _error_request === void 0 ? void 0 : _error_request.responseURL) !== null && _error_request_responseURL !== void 0 ? _error_request_responseURL : "";
                fluxErrorCode = (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : (_error_response_data_errors = _error_response_data.errors) === null || _error_response_data_errors === void 0 ? void 0 : (_error_response_data_errors_ = _error_response_data_errors[0]) === null || _error_response_data_errors_ === void 0 ? void 0 : _error_response_data_errors_.code;
                isAuthRequest = /\/api\/uapi(\/.*)?\/(login|logout)/.test(responseURL);
                if (!isAuthRequest) {
                    currentPath = "".concat(window.location.pathname).concat(encodeURIComponent(window.location.search));
                    if (status === 401) {
                        window.location.replace("/unauthorized?next=".concat(currentPath));
                    // TODO: Remove the IGNORED_403_ERROR_CODE as part of EXP-16358
                    } else if (status === 403 && fluxErrorCode !== IGNORED_403_ERROR_CODE) {
                        window.location.replace("/forbidden");
                    }
                }
                // If the original error has response data, generate a ResponseError from it
                return [
                    2,
                    Promise.reject(error.response ? new ResponseError(error.message, error.response) : error)
                ];
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return api;
};
